import React from "react";
import graybg from "../../Assets/1st_slider/Rectangle 4.png";
import grp5 from "../../Assets/1st_slider/Group 5.png";
import helthcare from "../../Assets/1st_slider/covid-19-preventing-virus-health-healthcare-workers-quarantine-concept-physician-medical-white-scrubs-attractive-female-doctor-showing-medicine-different-pills-smiling-as-recommend-it 1.png";
import frame from "../../Assets/1st_slider/Frame.png";
import Secound_slider from "./Secound_slider";

const One_slider = () => {
  return (
    <> 
    <div className="w-full bg-white py-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-[0.5rem] px-6 place-items-center">

        {/* Medicine */}
        <div
          className="relative w-[250px] h-[180px] rounded-[20px] bg-cover bg-center"
          style={{ backgroundImage: `url(${graybg})` }}
        >
          <img
            src={grp5}
            alt="Medicine"
            className="absolute w-[180px] h-[112px] top-[12px] left-[35px] object-contain"
          />
          <p className="absolute w-[86px] h-[24px] top-[135px] left-[82px] text-[20px] font-normal text-black bg-white/70 rounded-md flex items-center justify-center">
            Medicine
          </p>
        </div>

        {/* Health Care */}
        <div
          className="relative w-[250px] h-[180px] rounded-[20px] bg-cover bg-center"
          style={{ backgroundImage: `url(${graybg})` }}
        >
          <img
            src={helthcare}
            alt="Health Care"
            className="absolute w-[180px] h-[112px] top-[12px] left-[35px] object-contain"
          />
          <p className="absolute w-[110px] h-[24px] top-[135px] left-[70px] text-[20px] font-normal text-black bg-white/70 rounded-md flex items-center justify-center">
            Health Care
          </p>
        </div>

        {/* Health Blog */}
        <div
          className="relative w-[250px] h-[180px] rounded-[20px] bg-cover bg-center"
          style={{ backgroundImage: `url(${graybg})` }}
        >
          <img
            src={frame}
            alt="Health Blog"
            className="absolute w-[180px] h-[112px] top-[12px] left-[35px] object-contain"
          />
          <p className="absolute w-[110px] h-[24px] top-[135px] left-[70px] text-[20px] font-normal text-black bg-white/70 rounded-md flex items-center justify-center">
            Health Blog
          </p>
        </div>

      </div>
    </div>
     {/* <Secound_slider /> */}
    </>
  );
};

export default One_slider;
